import { Component, OnInit } from '@angular/core';
import { SidebarService } from './sidebar.service';
import {CompService} from './sidebar.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  compServices: CompService[];
  constructor(private sidebarService: SidebarService) { }

  ngOnInit() {
    this.getComponents();
  }

  getComponents(): void {
    this.sidebarService.getComponents()
      .subscribe(compServices => this.compServices = compServices);
  }
 select(comp, comps) {
    const index = comps.indexOf(comp);
    for (let j = 0; j < comps.length; j++) {
      if (j === index) {
        comps[j].selected = 'active-tab';
      } else {
        comps[j].selected = '';
      }
    }
 }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts